import React, { useEffect, useState } from "react";

const ShowHomeScoreboard = ({ object }) => {
  const [showLoader, setLoader] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoader(false);
    }, 1500);
    // setLoader(false);
  }, []);

  const matchDataDetails = object;
  const isEmpty = (v) => v == undefined || v == null || v == "";

  let scoreURL = "";
  let screenScore = "half";

  if (matchDataDetails?.scoreCustomUrl) {
    scoreURL = matchDataDetails?.scoreCustomUrl?.replace('rwb-dark','rwb-light');
    screenScore = "full";
  } else if (
    !isEmpty(matchDataDetails?.scoreId) &&
    matchDataDetails?.scoreId != "0"
  ) {
    scoreURL = `https://kurukwin.xyz/scorecard/${matchDataDetails?.eventType}/${matchDataDetails?.eventId}/${matchDataDetails?.scoreId}`;
  } else if (
    !isEmpty(matchDataDetails?.scoreId) &&
    matchDataDetails?.scoreId != "0" &&
    matchDataDetails?.provider != "diamond"
  ) {
    scoreURL = `https://kurukwin.xyz/scorecard/${matchDataDetails?.eventType}/${matchDataDetails?.eventId}/${matchDataDetails?.scoreId}`;
  }

  return (
    <div className="w-100" style={{ position: "relative" }}>
      {showLoader && (
        <div
          id="loading1"
          className="loading1 loading1Outer"
          style={{ display: `block` }}
        >
          <div className="loading-box1">
            <div className="loading-spinner"></div>
          </div>
        </div>
      )}
      <iframe
        style={{
          width: "100%",
          height:
            object?.status == "active"
              ? "200px"
              : screenScore == "full"
                ? "270px"
                : "200px",
        }}
        src={scoreURL}
      />
    </div>
  );
};

export default ShowHomeScoreboard;
